<template>
  <a-layout>
    <modify-table ref="modifyTable" style="margin-top: 2px" @reset="reset" @selectRow="selectRow"/>
    <modify-detail ref="modifyDetail" style="margin-top: 2px"/>
  </a-layout>
</template>
<script>
  import ModifyTable from '@/views/inbound/modify/ModifyTable.vue'
  import ModifyDetail from '@/views/inbound/modify/ModifyDetail.vue'

  export default {
    name: 'Modify',
    components: {ModifyDetail, ModifyTable},
    methods: {
      selectRow(no) {
        this.$refs.modifyDetail.fetch({'no': no})
      },
      reset() {
        this.$refs.modifyDetail.clear()
      }
    }
  }
</script>